import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import queryString from 'query-string';
import {withRouter} from 'react-router';
import {generateRoutePath} from 'epic-common/src/route';
import Header from './Header';
import BackgroundVideo from 'epic-react-common/src/components/BackgroundVideo';
import LoginActions from '../../actions/LoginActions';

class CreateSignUpPage extends React.Component {
    static propTypes = {
        content: PropTypes.object,
        isLoggedIn: PropTypes.bool,
        title: PropTypes.string,
        isGame: PropTypes.bool,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        location: PropTypes.object,
        contentRedeem: PropTypes.object,
        deviceSelect: PropTypes.bool,
        redeem: PropTypes.bool
    };

    getReturnPath = () => {
        const {redeem, deviceSelect, isGame} = this.props;
        const query = queryString.parse(this.props.location.search) || '';
        let returnPath = '';
        if (redeem) {
            returnPath = deviceSelect ? `/mobile/redeem-device-select?${queryString.stringify(query)}` : `/mobile/redeem-code?${queryString.stringify(query)}`;
        } else {
            returnPath = isGame ? `/mobile/iosgame-confirm?${queryString.stringify(query)}` : `/mobile/account-device-select?${queryString.stringify(query)}`;
        }
        return returnPath;
    };

    requestLogin = () => {
        LoginActions.requestLogin({
            returnPath: this.getReturnPath()
        });
    };

    render() {
        const {
            content, isLoggedIn, title, mobile, tablet, redeem, contentRedeem
        } = this.props;

        //switch between redeem / create content
        const titleContent = redeem ? contentRedeem.description : content.title;
        const buttonText = redeem ? contentRedeem.cta : content.cta;
        const buttonId = redeem ? 'createRedeem-btn' : 'CreateAccount-btn';
        //redirect
        const returnPath = this.getReturnPath();

        return (
            <div className="sign-up-page createAccount">
                <div className="header-wrapper">
                    <div className="container content-wrapper">
                        <div className="head">
                            <div className="content text-center">
                                <Header title={title} />
                                <div className="main-content" dangerouslySetInnerHTML={{__html: titleContent}} />
                                {content.note && !redeem ? (
                                    <p>{content.note}</p>
                                ) : null}
                                <div className="btn-container text-center">
                                    {!isLoggedIn ? (
                                        <button
                                            id={buttonId} onClick={this.requestLogin}
                                            className="btn btn-primary height">
                                            <span>{buttonText}</span>
                                            {content.emailReminder && !redeem ? (
                                                <span className="small">{content.emailReminder}</span>
                                            ) : null}
                                        </button>
                                    ) : (
                                        <Link
                                            id={buttonId} to={generateRoutePath(returnPath)}
                                            className="btn btn-primary height">
                                            <span>{buttonText}</span>
                                            {content.emailReminder && !redeem ? (
                                                <span className="small">{content.emailReminder}</span>
                                            ) : null}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="space-man" />
                    </div>
                </div>
                <div className="container-fluid white-bk">
                    <div className="container text-section text-center">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="embed-responsive embed-responsive-16by9 media-container">
                                    <BackgroundVideo
                                        background={content.video}
                                        play={false}
                                        noOverlay
                                        playsInline={mobile || tablet}
                                        loop
                                        enableRatioHelper={false}
                                        mobile={mobile}
                                        tablet={tablet} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="aux-message" dangerouslySetInnerHTML={{__html: content.description}} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(CreateSignUpPage);
